import isEqual from 'lodash-es/isEqual'

export default (obj1, obj2) => {
  return Object.keys(obj1).reduce((result, key) => {
    if (!obj2[key]) {
      result.push(key)
    } else if (isEqual(obj1[key], obj2[key])) {
      const resultKeyIndex = result.indexOf(key)
      result.splice(resultKeyIndex, 1)
    }
    return result
  }, Object.keys(obj2))
}
